import MainLayout from '../components/layout/MainLayout';
import ActiveEsps from '../components/ActiveEsps';

export default function ActiveEspsPage() {
    return (
        <MainLayout>
            <ActiveEsps />
        </MainLayout>
    );
}
